import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

/**
 * Reusable layout wrapper for legal pages.
 * Renders consistent typography for headings, paragraphs and lists.
 */
const LegalLayout = ({ title, lastUpdated, children }) => (
  <div className="min-h-screen bg-[#F5F5F5]">
    <Header />
    <main className="pt-24 pb-16 px-6">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-gray-400 hover:text-gray-900 text-sm mb-6"
          data-testid="legal-back-link"
        >
          <ArrowLeft size={16} />Accueil
        </Link>

        <article className="bg-white border border-gray-200 p-8 md:p-12 shadow-sm legal-content">
          <header className="mb-8 pb-6 border-b border-gray-200">
            <span className="text-[#E63946] text-xs uppercase tracking-[0.3em] font-bold">
              Information légale
            </span>
            <h1 className="font-['Outfit'] text-3xl md:text-4xl font-bold text-gray-900 mt-3">
              {title}
            </h1>
            {lastUpdated && (
              <p className="text-gray-400 text-sm mt-2">
                Dernière mise à jour : <strong className="text-gray-900">{lastUpdated}</strong>
              </p>
            )}
          </header>

          <div className="prose-legal text-gray-700 leading-relaxed space-y-5
                          [&_h2]:font-['Outfit'] [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-gray-900 [&_h2]:mt-8 [&_h2]:mb-3
                          [&_h3]:font-semibold [&_h3]:text-gray-900 [&_h3]:text-base [&_h3]:mt-5 [&_h3]:mb-2
                          [&_p]:text-gray-700 [&_p]:text-[15px]
                          [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_ul]:text-[15px]
                          [&_a]:text-[#E63946] [&_a]:underline hover:[&_a]:opacity-80
                          [&_strong]:text-gray-900 [&_strong]:font-semibold">
            {children}
          </div>
        </article>
      </div>
    </main>
    <Footer />
  </div>
);

export default LegalLayout;
